module.exports = require('linkifyjs/lib/plugins/mention');
